import { render } from "./AlzataSplashImage.vue?vue&type=template&id=ba6ecf56"
import script from "./AlzataSplashImage.vue?vue&type=script&lang=js"
export * from "./AlzataSplashImage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__